export default __webpack_public_path__ + "static/media/wallpaperflare.com_wallpaper.324b4fe4.jpg";